
export class StringUtils {

  public static nameToId(name) {
    let id = name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9]/g, '');
    return id;
  }


}



// WEBPACK FOOTER //
// ./common/utils/stringutils.ts